export const environment = {
  production: false,

  // Backend URLs
  apiUrl: '/api',    // CAC Python Backend (FastAPI) via Angular proxy in local
  casApiUrl: '/cas-api', // Spring Boot Backend (CAS v2) via Angular proxy in local
  cacApiUrl: '/api', // Compat legacy key via Angular proxy in local
  flaskUrl: '/flask-api',  // Flask Backend (Comparateur) via Angular proxy in local

  apiEndpoint: '/api',
  baseHref: '/',
  enableLogging: true,
  enableDebugTools: true,
  apicilPartnerCode: '0039587',

  // Endpoints Spring Boot (Port 8081) - Tarification et Devis
  endpoints: {

    // Alptis
    alptis: {
      tarification: '/api/v1/tarification/alptis',
      offres: '/api/v1/tarification/alptis/offres',
      // Génération de devis PDF via AlptisQuoteController
      // /api/alptis/generate-devis?test=false|true
      devis: '/api/alptis/generate-devis?test=false',
      devisTest: '/api/alptis/generate-devis?test=true',
      // Le backend Spring expose ces endpoints sous /cas/api/alptis/v1/...
      etudePersonnaliseeBase: '/cas/api/alptis/v1/projets',
      etudePersonnaliseeGenerate: '/cas/api/alptis/v1/etude-personnalisee',
      santeProPlus: '/api/alptis/sante-pro-plus/tarification',
      lumineis: '/api/v1/alptis/lumineis/tarification'
    },

    // Apivia
    apivia: {
      tarification: '/cas/api/v1/tarification/apivia',
      produits: '/cas/api/v1/tarification/apivia/produits',
      devis: '/cas/api/apivia/generate-devis'
    },

    // April
    april: {
      projects: '/cas/api/healthProtection/projects'
    },

    // Generali
    generali: {
      tarification: '/api/v1/generali/tarification',
      compositions: '/api/v1/generali/compositions',
      formules: '/api/v1/generali/formules',
      santePro: {
        tarification: '/api/v1/generali/sante-pro/tarification',
        formules: '/api/v1/generali/sante-pro/formules',
        compositions: '/api/v1/generali/sante-pro/compositions',
        zones: '/api/v1/generali/sante-pro/zones'
      }
    },

    // 2MA (Acheel, 3CAO, 2Maltitude)
    deuxma: {
      acheel: '/cas/api/deuxma/v1/tarifs/acheel',
      troiscao: '/cas/api/deuxma/v1/3cao/tarification',
      troiscaoDevis: '/cas/api/deuxma/v1/3cao/devis',
      deuxmaltitude: '/cas/api/deuxma/v1/2maltitude/tarification',
      deuxmaltitudeDevis: '/cas/api/deuxma/v1/2maltitude/devis'
    },

    // Utwin
    utwin: {
      tarification: '/api/utwin/tarification',
      souscription: '/api/utwin/souscription',
      propositionCommerciale: '/api/utwin/proposition-commerciale',
      documents: '/api/utwin/documents'
    },

    // Zenioo
    zenioo: {
      tarification: '/api/v1/zenioo/tarification',
      products: '/api/v1/zenioo/products',
      formulas: '/api/v1/zenioo/formulas',
      options: '/api/v1/zenioo/options',
      quotationDocument: '/api/v1/zenioo/quotation-document',
      detailedOffer: '/api/v1/zenioo/detailed-offer',
      subscriptionForm: '/api/v1/zenioo/subscription-form',
      subscriptionDocument: '/api/v1/zenioo/subscription-document',
      uploadSignedDocument: '/api/v1/zenioo/upload-signed-document',
      validateSubscription: '/api/v1/zenioo/validate-subscription',
      uploadDocumentToSign: '/api/v1/zenioo/upload-document-to-sign',
      sendESignatureLink: '/api/v1/zenioo/send-esignature-link'
    },

    // Neoliane V2 (EZAPI)
    neolianeV2: {
      profile: '/api/v1/neoliane/v2/profile',
      generatePrices: '/api/v1/neoliane/v2/profile/{profileId}/generateprices',
      cart: '/api/v1/neoliane/v2/profile/{profileId}/cart',
      quotation: '/api/v1/neoliane/v2/profile/{profileId}/pricing/{pricingId}/quotation',
      quotationDownload: '/api/v1/neoliane/v2/profile/{profileId}/pricing/{pricingId}/quotation/download'
    },

    // APICIL
    apicil: {
      tarification: '/api/v1/apicil/tarification',
      creationDevis: '/api/v1/apicil/creation-devis',
      telechargementLiasse: '/api/v1/apicil/devis',
      demarrerSouscription: '/api/v1/apicil/souscriptions',
      statutDevis: '/api/v1/apicil/statut-devis',
      referentielPays: '/api/v1/apicil/referentiel-pays',
      referentielActivites: '/api/v1/apicil/referentiel-activites'
    }
  },

  // Endpoints Flask (Port 5000) - Comparateur uniquement
  flaskEndpoints: {
    comparateur: '/compare',
    contracts: '/api/contracts',
    adminContracts: '/api/admin/contracts',
    adminProducts: '/api/admin/products',
    extract: '/extract',
    uploadLogo: '/api/admin/logos/upload',
    extractEnterprise: '/extract-enterprise',
    chatbot: '/chatbot',
    tarif: '/api/tarif'
  }
};
